import { RootState } from "../store";

export const all = (state: RootState) => state.notificationReducer;

export const notificationList = (state: RootState) =>
  all(state).notificationList;

export const isCollapsed = (state: RootState) => all(state).isCollapsed;

export const isReadList = (state: RootState) => all(state).isReadList;
